import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    body {
      margin: 0; line-height: normal;
    }
:root {

/* fonts */
--font-product-sans: 'Product Sans';
--font-audiowide: Audiowide;
--font-montserrat: Montserrat;

/* font sizes */
--font-size-xs: 12px;
--font-size-base: 16px;
--font-size-sm: 14px;
--font-size-lg: 18px;
--font-size-3xs: 10px;
--font-size-15xl: 34px;
--font-size-smi-5: 12.5px;



/* Colors */
--light-theme-ffffff-100: #fff;
--light-theme-595959: #595959;
--color-dodgerblue: #4285f4;
--color-black: #000;

--color-whitesmoke-100: #f9f9f9;
  --color-whitesmoke-200: #f2f2f2;
  --color-whitesmoke-300: #ebebee;
  --color-dimgray: #595959;
  --color-black: #000;
  --color-forestgreen-100: #08a32a;
  --color-forestgreen-100: #08a32a;
  --color-gray-100: #7b7b7b;
  --color-white: #fff;
  --color-lightgreen: #b0ffa9;
  --color-darkgray: #959595;
  --color-orange-100: #fbbc05;

/* border radiuses */
--br-xs: 12px;
--br-5xs: 8px;
--br-11xl: 30px;

}


`;




 
